import memoize from 'transmute/memoize';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { jsx as _jsx } from "react/jsx-runtime";
//  The loading overlay requires a relative positioned parent.
//  The loading overlay also has a top & bottom padding of 60px and is absolute positioned,
//  so we need to size our div so the overlay doesn't overflow below this engagement
const StyledDiv = styled.div.withConfig({
  displayName: "AsyncComponentLoadingHandler__StyledDiv",
  componentId: "sc-13qolif-0"
})(["position:relative;width:100%;min-height:120px;"]);
const propTypes = {
  isContextual: PropTypes.bool
};
export const AsyncComponentLoadingHandler = memoize(({
  isContextual = false
} = {}) => {
  return function asyncComponentLoadingHandler() {
    return /*#__PURE__*/_jsx(StyledDiv, {
      children: /*#__PURE__*/_jsx(LoadingOverlay, {
        contextual: isContextual,
        layout: "centered"
      })
    });
  };
});
AsyncComponentLoadingHandler.propTypes = propTypes;